// extracted by mini-css-extract-plugin
export const container = "StaticLayout-module--container--1gyoW";
export const content = "StaticLayout-module--content--VkjJs";